<template>
  <div>
    <header-info cur="1"></header-info>
    <div id="menu"></div>
    <div id="center">
      <div
        id="content"
        class="content"
      >
        <div class="list">
          <div class="title clearfix">
            <p>修改/找回密码</p>
          </div>
          <div
            class="listbox clearfix"
            id="list"
          >
            <div
              class="main"
              v-if="step==1"
            >
              <p class="tip"></p>
              <form
                class="login_form"
                id="regForm"
              >
                <div class="login_item">
                  <input
                    class="ipt"
                    type="text"
                    v-model="formInfo.mobile"
                    placeholder="手机号"
                    required=""
                    autocomplete="off"
                    maxlength="11"
                  >
                </div>
                <div class="login_item item-verify">
                  <input
                    v-model="verifyCode.code"
                    class="ipt verify"
                    type="text"
                    autocomplete="off"
                    placeholder="输入图形验证码"
                    required=""
                  >
                  <span
                    @click="getVerifyCode"
                    class="verify-code"
                    title="看不清，换一个"
                  ><img :src="formatImage(verify.path)"></span>
                </div>
                <div class="login_item item-verify">
                  <input
                    v-model="formInfo.mobile_code"
                    class="ipt verify"
                    type="text"
                    autocomplete="off"
                    placeholder="输入短信验证码"
                    required=""
                  >
                  <span
                    class="code"
                    @click="sendMsg"
                    :style="isMsgSend ? 'background:#ccc' : ''"
                  >
                    {{ this.isMsgSend ? '' + this.seconds + '秒' : '获取验证码' }}
                  </span>
                </div>

              </form>
              <div
                class="login_btn"
                id="loginBut"
                @click="nextStep"
              >下一步</div>
            </div>
            <div
              class="main"
              v-if="step==2"
            >
              <p class="tip"></p>
              <form
                class="login_form"
                id="regForm"
              >
                <div class="login_item">
                  <input
                    class="ipt"
                    type="password"
                    placeholder="请输入密码"
                    required=""
                    autocomplete="off"
                    v-model="formInfo.password1"
                  >
                </div>
                <div class="login_item">
                  <input
                    class="ipt"
                    type="password"
                    placeholder="请确认密码"
                    required=""
                    autocomplete="off"
                    v-model="formInfo.password2"
                  >
                </div>

              </form>
              <div
                class="login_btn"
                id="loginBut"
                @click="changePassword"
              >确定</div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div
      id="south"
      ref="south"
    >
      <footer-info></footer-info>
    </div>
  </div>
</template>

<script>
import HeaderInfo from '../../../components/HeaderInfo'
import FooterInfo from '../../../components/FooterInfo'
import { uuid } from 'vue-uuid'
export default {
  name: 'FindPassword',
  components: {
    HeaderInfo,
    FooterInfo
  },
  data() {
    return {
      client_id: '',
      formInfo: {
        mobile: '',
        mobile_code: '',
        password1: '',
        password2: ''
      },
      verifyCode: {
        code: ''
      },
      verify: {
        path: '',
        show: false
      },
      step: 1,
      smsVerifyCode: '',
      isMsgSend: false,
      interval: null,
      seconds: 0,
      profileId: '',
      pwdForm: {
        password1: '',
        password2: ''
      }
    }
  },
  methods: {
    async nextStep() {
      var mobile = /^1[3456789]\d{9}$/ // 手机号
      if (!this.formInfo.mobile) {
        this.$layer.msg('手机号不能为空！')
        return
      } else if (!mobile.test(this.formInfo.mobile)) {
        this.$layer.msg('手机号格式有误！')
        return
      } else if (this.verify.show && !this.verifyCode.code) {
        this.$layer.msg('请输入图形验证码！')
        return
      } else if (!this.formInfo.mobile_code) {
        this.$layer.msg('请输入短信验证码！')
        return
      }
      const ckData = await this.$http.post('/login_code/', {
        client_id: this.client_id,
        code: this.verifyCode.code
      })

      if (ckData.code !== '200') {
        this.$layer.msg(ckData.msg)
        return
      }
      const checkMobileCode = await this.$http.post('/send_mobile/', {
        client_id: this.client_id,
        code: this.formInfo.mobile_code
      })
      if (checkMobileCode.code === '200') {
        this.step = '2'
      } else {
        this.$layer.msg(checkMobileCode.msg)
      }
    },

    async getVerifyCode() {
      await this.$http.get('/login_code/', {
        params: {
          client_id: this.client_id
        }
      }).then(async (data) => {
        this.verify.path = data.path
        this.verify.show = true
      }).catch((error) => {
        console.log(error)
      })
    },

    formatImage (path) {
      return this.$store.state.rootUrl + path
    },
    async sendMsg() {
      var mobile = /^1[3456789]\d{9}$/ // 手机号
      if (this.isMsgSend === true) {
        return
      } else if (!this.formInfo.mobile) {
        this.$layer.msg('手机号不能为空！')
        return
      } else if (!mobile.test(this.formInfo.mobile)) {
        this.$layer.msg('手机号格式有误！')
        return
      }
      await this.$http.get('/send_mobile/', {
        params: {
          client_id: this.client_id,
          mobile: this.formInfo.mobile,
          template: 'SMS_238150787'
        }
      }).then((data) => {
        this.$layer.msg('验证码已发送，有效期两分钟！')
        this.isMsgSend = true
        this.seconds = 120
        this.interval = setInterval(() => {
          if (this.seconds === 0) {
            clearInterval(this.interval)
            this.isMsgSend = false
          }
          this.seconds -= 1
        }, 1000)
      }).catch(() => {
        this.$layer.msg('发送验证码失败！')
      })
    },
    async changePassword () {
      if (this.formInfo.password1.trim() === '') {
        this.$layer.msg('请输入密码')
        return false
      }
      var testPassword = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,64}$/
      if (testPassword.test(this.formInfo.password1) === false) {
        this.$layer.msg('密码须同时包含大写字母、小写字母、数字、特殊字符中的任意三种')
        return false
      }
      var Email = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      if (Email.test(this.formInfo.password1) === true) {
        this.$layer.msg('密码不能是邮箱')
        return false
      }
      if (this.formInfo.password2.trim() === '') {
        this.$layer.msg('请输入确认密码')
        return false
      }
      if (this.formInfo.password1.length < 8) {
        this.$layer.msg('密码至少8位')
        return false
      }

      if (this.formInfo.password1.length > 64) {
        this.$layer.msg('密码最多64位')
        return false
      }

      if (this.formInfo.password1 !== this.formInfo.password2) {
        this.$layer.msg('新密码和确认密码不一致')
        return false
      }
      await this.$http.post('/forgot_pwd_by_mobile/', {
        client_id: this.client_id,
        mobile: this.formInfo.mobile,
        mobile_code: this.formInfo.mobile_code,
        password1: this.utils.encryptDes(this.formInfo.password1),
        password2: this.utils.encryptDes(this.formInfo.password2)
      }).then(async (data) => {
        this.$layer.msg(data.msg)
        if (data.code === '200') {
          this.$router.push('/login')
        }
      }).catch((error) => {
        console.dir(error)
        this.$layer.msg('重置密码失败！')
      })
    }
  },
  mounted() {
    this.client_id = uuid.v1()
    this.getVerifyCode()
  }
}
</script>
<style scoped src="../../../assets/css/dialog.css"></style>
<style scoped src="../../../assets/css/common.css"></style>

<style scoped src="../../../assets/css/header.css"></style>
<style scoped src="../../../assets/css/footer.css"></style>

<style scoped src="../../../assets/css/forget.css"></style>
<style lang="less" scoped>
#south {
  width: 100%;
  bottom: 0px;
}

.container {
  height: 100%;
}
/deep/#south {
  position: relative;
}
#layout {
  height: 98%;
  visibility: visible;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-content: center;
}
#app #center {
  padding-bottom: 0;
}
#app > div {
  height: 100vh;
  min-height: 100vh;
}
.code {
  background: #73D6CA;
  display: inline-block;
  width: 120px;
  height: 50px;
  color: #fff;
  line-height: 50px;
  text-align: center;
  cursor: pointer;
}
.login_item {
  margin-bottom: 20px;
}
.main {
  padding-bottom: 0;
}
.tips {
  text-align: left;
}
.list {
  margin: 0 auto;
}
#center {
  min-height: calc(100vh - 295px);
  padding-top: 30px;
  box-sizing: border-box;
}
.item-verify {
  display: flex;
}
.verify {
  flex: 1;
}
.ipt {
  padding-left: 10px;
}
</style>
